<!-- Shared Elegant Loader -->
<app-elegant-loader *ngIf="isLoadingUserPermissions" [id]="'user-permissions-loader'" [loadingText]="'Loading User Permissions'"></app-elegant-loader>

<!-- Main Content (Hidden while loading) -->
<ng-container *ngIf="!isLoadingUserPermissions">
  <!-- Example structure for Prosumer Permissions -->
  <section class="config-card">
    <div class="config-card__left">
      <h3 class="config-title">Prosumer Permissions</h3>
    </div>
    <div class="config-card__right">
      <!-- Clicking opens the dialog for Prosumer -->
      <div>
        <button class="view-config" (click)="openDialog('prosumer')">
          View Configuration
          <div class="forward-btn">
            →
          </div>
        </button>
      </div>
    </div>
  </section>

  <!-- Example structure for Consumer Permissions -->
  <section class="config-card">
    <div class="config-card__left">
      <h3 class="config-title">Consumer Permissions</h3>
    </div>
    <div class="config-card__right">
      <!-- Clicking opens the dialog for Consumer -->
      <div>
        <button class="view-config" (click)="openDialog('consumer')">
          View Configuration
          <div class="forward-btn">
            →
          </div>
        </button>
      </div>
    </div>
  </section>
</ng-container>

<!-- 
  Custom Dialog Overlay
  Displayed only when showDialog is true.
-->
<div class="modal-overlay" *ngIf="showDialog">
  <div class="modal-content">
    <!-- Close Button -->
    <button type="button" class="close-modal-btn" (click)="discardChanges()">&times;</button>

    <!-- Dialog Title based on selected type -->
    <h2>
      Configure the
      <span *ngIf="selectedPermissionType === 'consumer'">Consumer</span>
      <span *ngIf="selectedPermissionType === 'prosumer'">Prosumer</span>
      Permissions
    </h2>

    <!-- For Consumer Permissions -->
    <div class="permission-options" *ngIf="selectedPermissionType === 'consumer'">
      <label class="checkbox-label">
        <div class="main">
          <input type="checkbox" [(ngModel)]="consumerPermissions.buy" [disabled]="isSavingUserPermissions" />
          <span>Buy</span>
        </div>
        <p>(Consumers can buy energy)</p>
      </label>
      <label class="checkbox-label">
        <div class="main">
          <input type="checkbox" [(ngModel)]="consumerPermissions.sell" [disabled]="isSavingUserPermissions" />
          <span>Sell</span>
        </div>
        <p>Consumers can sell energy</p>
      </label>
    </div>

    <!-- For Prosumer Permissions -->
    <div class="permission-options" *ngIf="selectedPermissionType === 'prosumer'">
      <label class="checkbox-label">
        <div class="main">
          <input type="checkbox" [(ngModel)]="prosumerPermissions.buy" [disabled]="isSavingUserPermissions" />
          <span>Buy</span>
        </div>
        <p>(Prosumers can buy energy)</p>
      </label>
      <label class="checkbox-label">
        <div class="main">
          <input type="checkbox" [(ngModel)]="prosumerPermissions.sell" [disabled]="isSavingUserPermissions" />
          <span>Sell</span>
        </div>
        <p>(Prosumers can sell energy)</p>
      </label>
      <!-- Add more checkboxes if needed for Prosumer-specific features -->
    </div>

    <div class="dialog-buttons">
      <button class="btn btn--primary" [disabled]="isSavingUserPermissions" (click)="saveConfiguration()">
        {{ isSavingUserPermissions ? 'Saving...' : 'Save Configuration' }}
      </button>
      <button class="btn btn--secondary" [disabled]="isSavingUserPermissions" (click)="discardChanges()">Discard Changes</button>
    </div>
  </div>
</div>